import { ComponentProps } from 'react';

import { Text } from '@eneco/sparky';
import { getClassNames } from '@eneco/sparky/util/css';

import { styledTextClass } from './Header.css';

interface StyledTextProps extends ComponentProps<typeof Text> {
  className?: string;
}

export const StyledText = ({ className, ...props }: StyledTextProps) => (
  <Text className={getClassNames(styledTextClass, className)} {...props} />
);
